"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Customer = _interopRequireDefault(require("../model/Customer"));
var _Group = _interopRequireDefault(require("../model/Group"));
var _Message = _interopRequireDefault(require("../model/Message"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* OrganizationGroups service.
* @module api/OrganizationGroupsApi
* @version 3.0
*/
var OrganizationGroupsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new OrganizationGroupsApi. 
  * @alias module:api/OrganizationGroupsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OrganizationGroupsApi(apiClient) {
    _classCallCheck(this, OrganizationGroupsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Gets the Group details
   * Gets the details of a Group.
   * @param {Number} groupId ID of the group
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Group} and HTTP response
   */
  return _createClass(OrganizationGroupsApi, [{
    key: "getGroupWithHttpInfo",
    value: function getGroupWithHttpInfo(groupId) {
      var postBody = null;
      // verify the required parameter 'groupId' is set
      if (groupId === undefined || groupId === null) {
        throw new Error("Missing the required parameter 'groupId' when calling getGroup");
      }
      var pathParams = {
        'groupId': groupId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Group["default"];
      return this.apiClient.callApi('/groups/{groupId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Group details
     * Gets the details of a Group.
     * @param {Number} groupId ID of the group
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Group}
     */
  }, {
    key: "getGroup",
    value: function getGroup(groupId) {
      return this.getGroupWithHttpInfo(groupId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Gets the Group customers
     * Gets the Customers which are part of the Group
     * @param {Number} groupId ID of the group
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Customer>} and HTTP response
     */
  }, {
    key: "getGroupCustomersWithHttpInfo",
    value: function getGroupCustomersWithHttpInfo(groupId) {
      var postBody = null;
      // verify the required parameter 'groupId' is set
      if (groupId === undefined || groupId === null) {
        throw new Error("Missing the required parameter 'groupId' when calling getGroupCustomers");
      }
      var pathParams = {
        'groupId': groupId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Customer["default"]];
      return this.apiClient.callApi('/groups/{groupId}/customers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Gets the Group customers
     * Gets the Customers which are part of the Group
     * @param {Number} groupId ID of the group
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Customer>}
     */
  }, {
    key: "getGroupCustomers",
    value: function getGroupCustomers(groupId) {
      return this.getGroupCustomersWithHttpInfo(groupId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();